import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
  'common',
  'contact',
  'home',
  'navigation',
  'projects',
]);

export type ProjectsConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};

export const projectsConfig: ProjectsConfig = {
  i18nNamespaces,
};
